import { IconButton } from '@mui/material';
import { KeyboardDoubleArrowRight } from '@mui/icons-material';
import tid from '@/common/infrastructure/config/tid';
import { BORDER_COLORS } from '@/common/presentation/constants/colors';

interface CloseDrawerButtonProps {
  onClick: () => void;
}

export default function CloseDrawerButton({ onClick }: Readonly<CloseDrawerButtonProps>) {
  return (
    <IconButton
      aria-label="close"
      onClick={onClick}
      sx={{
        color: BORDER_COLORS.LIGHT,
        border: `1px solid ${BORDER_COLORS.LIGHT}`,
        borderRadius: '4px',
        height: '24px',
        width: '24px'
      }}
      {...tid('common:close-drawer-button:button')}
    >
      <KeyboardDoubleArrowRight />
    </IconButton>
  );
}
